(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wmr-cart-consent"] && !Shopify.designMode) return;
  try {
    const consentRoot = document.querySelector('[data-wmr-cart-consent]');

  if (consentRoot) {
    const terms = consentRoot.querySelector('[data-wmr-consent-terms]');
    const digital = consentRoot.querySelector('[data-wmr-consent-digital]');
    const eventConsent = consentRoot.querySelector('[data-wmr-consent-event]');
    const error = consentRoot.querySelector('[data-wmr-consent-error]');
    const requiresDigital = consentRoot.dataset.requiresDigital === 'true';
    const requiresEvent = consentRoot.dataset.requiresEvent === 'true';
    let submitting = false;

    const valid = () => terms.checked && (!requiresDigital || digital?.checked) && (!requiresEvent || eventConsent?.checked);

    const saveConsent = async () => {
      const timestamp = new Date().toISOString();
      const version = consentRoot.dataset.consentVersion;
      const attributes = {
        'Einwilligung AGB und Datenschutz': `Ja | ${timestamp} | ${version}`,
        'Einwilligung Textversion': version
      };

      if (requiresDigital) {
        attributes['Ausdrücklicher digitaler Leistungsbeginn'] = `Ja | ${timestamp} | ${version}`;
        attributes['Bestätigung Verlust Widerrufsrecht digital'] = `Ja | ${timestamp} | § 356 Abs. 5 BGB`;
      }

      if (requiresEvent) {
        attributes['Bestätigung kein Widerrufsrecht Termin'] = `Ja | ${timestamp} | § 312g Abs. 2 Nr. 9 BGB | ${version}`;
        attributes['Bestätigte Terminprodukte'] = consentRoot.dataset.eventProducts;
      }

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes })
      });

      if (!response.ok) throw new Error('Consent could not be stored');
    };

    document.addEventListener('click', async (clickEvent) => {
      const checkout = clickEvent.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
      if (!checkout || submitting) return;
      clickEvent.preventDefault();
      clickEvent.stopImmediatePropagation();

      if (!valid()) {
        error.hidden = false;
        consentRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      error.hidden = true;
      submitting = true;
      checkout.setAttribute('aria-busy', 'true');

      try {
        await saveConsent();
        window.location.assign('/checkout');
      } catch (_error) {
        submitting = false;
        checkout.removeAttribute('aria-busy');
        error.textContent = 'Die Bestätigung konnte nicht gespeichert werden. Bitte versuche es erneut.';
        error.hidden = false;
      }
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wmr-legal-rail"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const checkoutLink = event.target.closest('a[href*="/checkout"]');
    if (!checkoutLink || window.location.pathname === '/cart') return;
    event.preventDefault();
    window.location.assign('/cart');
  });
  } catch(e) { console.error(e); }
})();

})();
